import { combineReducers, configureStore } from "@reduxjs/toolkit";
import vpsReducer from "features/vps/vpsSlice";
import serverReducer from "features/server/serverSlice";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "../features/common/auth/authSlice";
import cartReducer from "../features/common/layouts/cartSlice";
import stepReducer from "../features/common/layouts/stepSlice";
import productsReducer from "../features/common/products/productsSlice";
import diegoVpnReducer from "../features/diegoVpn/diegoVpnSlice";
import digitalSignatureReducer from "../features/digitalSignature/digitalSignatureSlice";
import domainReducer from "../features/domain/domainsSlice";
import emailSuiteReducer from "../features/emailSuite/emailSuiteSlice";
import hostingReducer from "../features/hosting/hostingSlice";
import sslReducer from "features/ssl/sslSlice";
import upgradeReducer from "../features/upgrade/upgradeSlice";
import renewReducer from "../features/renew/renewSlice";
import addonReducer from "../features/addon/addonSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: [
    "hosting",
    "vps",
    "server",
    "domain",
    "emailSuite",
    "digitalSignature",
    "vpn",
    "auth",
    "products",
    "upgrade",
    "renew",
    "addon",
  ],
};

const reducer = combineReducers({
  auth: authReducer,
  products: productsReducer,
  hosting: hostingReducer,
  vps: vpsReducer,
  server: serverReducer,
  cart: cartReducer,
  domain: domainReducer,
  step: stepReducer,
  emailSuite: emailSuiteReducer,
  digitalSignature: digitalSignatureReducer,
  vpn: diegoVpnReducer,
  ssl: sslReducer,
  upgrade: upgradeReducer,
  renew: renewReducer,
  addon: addonReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV === "development", // ! Development Only
});

export default store;
